export const fieldNames = {
  files: 'files',
};
